import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setAuthorization from '../utils/helpers/setAuthorization'
import { API_BASE_URL } from '../constants/api'

const companyRepository = createApi({
	reducerPath: 'companyRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['Company'],
	endpoints: (builder) => ({
		get: builder.query<
			{
				id: number
				nome: string
				gerente: string
				dominio: string
				funcionarios: number
				logo: string
				modo_curso_unico: boolean
				white_label: boolean
				color_primary: string
				avatar: string
				createdAt: string
				updatedAt: string
				slug: string
				deletedAt: Date
			},
			{ companyId: number }
		>({
			query: ({ companyId }) => ({
				url: `/v1/companies/company/saas/${companyId}`,
				method: 'GET',
			}),
			providesTags: ['Company'],
		}),
		getMutation: builder.mutation<
			{
				id: number
				nome: string
				gerente: string
				dominio: string
				funcionarios: number
				logo: string
				modo_curso_unico: boolean
				white_label: boolean
				avatar: string
				color_primary: string
				createdAt: string
				updatedAt: string
				slug: string
				deletedAt: Date
			},
			{ companyId: number }
		>({
			query: ({ companyId }) => ({
				url: `/v1/companies/company/saas/${companyId}`,
				method: 'GET',
			}),
			invalidatesTags: ['Company'],
		}),
	}),
})

export default companyRepository
